export { default as LoginPage } from './LoginPage';



// WEBPACK FOOTER //
// ./src/auth/index.js